// GENIEEのLINE登録促進モーダルの出し分け設定。
//
// 従来はGTMがページビューで直接GENIEEタグを配信し、40秒の待機と操作によるリセットを
// GENIEE側が持っていた。その結果「フォームのステップを進めている＝登録意思がある人」にも
// 同じステップで40秒経つとモーダルが出てしまい、成果課金の対象になっていた。
//
// 本対応でGENIEE側の表示遅延を0秒にし、待機と表示判定をこのアプリが持つ形に反転させている。
// アプリは条件を満たしたときに dataLayer へイベントを1回投げるだけで、
// GENIEEタグ本体の配信はGTMのカスタムイベントトリガーに任せる（タグの実体はGTM側に置いたまま）。

// GTMのカスタムイベントトリガー名。GTM側の設定と一致していること
export const PROMO_READY_EVENT = 'geniee_line_promo_ready'

// 抑止された事実の計測用。GTM側ではGA4への送信にのみ使う
export const PROMO_SUPPRESSED_EVENT = 'geniee_line_promo_suppressed'

// フォームへの最後の操作から この時間 無操作で表示する。
// 従来GENIEE側に設定されていた40秒を踏襲。以後の調整はGENIEEへの依頼不要でここを変えるだけ
export const IDLE_DELAY_MS = 40_000

// 対象ページ。増やすときはここだけ触る
const TARGET_PATH_PATTERNS: RegExp[] = [/^\/instagram_asc\/?$/]

export const isTargetPath = (pathname: string): boolean =>
    TARGET_PATH_PATTERNS.some((pattern) => pattern.test(pathname))

// SP限定。PC版フォームは旧jQuery製（_ag_entry_form_light.html.erb）でStepContextを通らず、
// ステップ進行による抑止が効かないため対象外にする。PCでも動かすと「抑止なしで表示だけ増える」
// 状態になり、本対応の目的と逆行する。
// 閾値は pages/style.scss の .sp / .pc 出し分け（max-width: 750px）に合わせている
export const isTargetViewport = (): boolean =>
    window.matchMedia('(max-width: 750px)').matches
